class Animator {
    elapsed: number;
    pause: boolean;
    countFrames: boolean;
    fps: number;
    animationSequence: () => void;

    constructor(countFrames = false) {
        this.elapsed = 0;
        this.pause = true;
        this.countFrames = countFrames;
        this.fps = 0;
        this.animationSequence = () => {};
    }

    animationStart() {
        let previousTimeStamp: number;
        let previousFpsTime: number;
        this.pause = false;
        let framecount = 0;
        const step = (timeStamp: number) => {
            if (!this.pause) {
                if (framecount % 10 == 0 && framecount > 0) {
                    this.fps = Math.floor(1000 / ((timeStamp - previousFpsTime) / 10));
                    previousFpsTime = timeStamp
                }
                if (!previousTimeStamp) previousTimeStamp = timeStamp;
                if (!previousFpsTime) previousFpsTime = timeStamp;
                this.elapsed += timeStamp - previousTimeStamp;
                if (this.countFrames) console.log(framecount)
                framecount ++;
                if (previousTimeStamp !== timeStamp) {
                    this.animationSequence();
                }
                previousTimeStamp = timeStamp;
                window.requestAnimationFrame(step);
            }
        }
        window.requestAnimationFrame(step);
    }

    animationPause() {
        this.pause = true;
    }

    animationRestart() {
        this.elapsed = 0;
    }

    record = async (frames: number, delay: number, source: HTMLCanvasElement, fps: number = this.fps) => {
        this.animationPause();
        const interval = 1000 / fps;
        for (let i = 0; i < frames; i++) {
            this.animationSequence();
            this.elapsed += interval;
            const image = source.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = image;
            link.download = `frame_${i}.png`;
            await new Promise((resolve) => {
                link.addEventListener('click', () => {
                    setTimeout(resolve, delay);
                });
                link.click();
            });
        }

        this.animationStart();
    }
}

export default Animator